import Grid from '../components/grid'
import IntHighlightItem from '../components/int-highlight-item'
import Container from '../components/ui/container'
import { Page } from '@telesoft/types/payload-types'
import React, { ReactElement } from 'react'

export type BlockProps = Extract<Page['blocks'][0], { blockType: 'int-cluster' }>

export default function IntCluster(block: BlockProps): ReactElement {
  const { items } = block
  const titleSize = block?.options?.titleSize ?? null

  return (
    <Container>
      <Grid>
        {items.map((item: any, i: number) => {
          return (
            <IntHighlightItem
              key={`int-highlight--${i}`}
              title={item.title}
              titleSize={titleSize?.toString() ?? '42'}
              subTitle={item.description}
            />
          )
        })}
      </Grid>
    </Container>
  )
}
